import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {Folder, FourDService, Job, Transform} from '4d-mapper';
import {MatDialog, MatSnackBar} from '@angular/material';
import {AppService} from '../../../../commons/app.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MapService} from '../../../../commons/map.service';
import {MainService} from '../../../main.service';
import {Location} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {MapComponent} from '../../map.component';
import {TranslateService} from '@ngx-translate/core';
import {AppBaseComponent} from '../../../../commons/AppBaseComponent';
import {Subscription, forkJoin} from 'rxjs/index';
import { flatMap,map } from 'rxjs/operators';
import { XsApplicationEventsService } from '../../../../xs/services/events/application-events.service';
import { Constants } from '../../../../commons/Constants';

@Component({
  selector: 'app-terrain-compare',
  templateUrl: './terrain-compare.component.html',
  styleUrls: ['./terrain-compare.component.scss']
})
export class TerrainCompareComponent extends AppBaseComponent implements OnInit, AfterViewInit, OnDestroy {

  debug:boolean = Constants.debug_off;

  selectedDesignTransformA : Transform;
  selectedDesignTransformB : Transform;

  transform: Transform;
  allSceneTransformsA: Transform[] = [];
  allSceneTransformsB: Transform[] = [];


  constructor(private fourD: FourDService, public service: AppService, private r: Router, sn: MatSnackBar, d: MatDialog, private t: TranslateService, private mainService: MainService, private trans: TranslateService,
              private mapService: MapService, private httpClient: HttpClient, private ar: ActivatedRoute, private mapComp: MapComponent, private location: Location, applicationEvents:XsApplicationEventsService) {
    super(service, r, sn, d, applicationEvents);
    this.mapComp.detailsNav.open();
  }

  compare(){
    this.createJob();
    this.navigateBack(this.location);
  }

  private createJob() {
    if(this.selectedDesignTransformA && this.selectedDesignTransformB && this.selectedDesignTransformA.id === this.selectedDesignTransformB.id){
      this.openSnackBarError('MAP.TERRAIN.COMPARE_ERROR');
      return;
    }
    var jobType = this.fourD.jobTypes.find(jt => jt['uid'] == 'terrain-compare');
    if ( this.debug ) { console.log ( 'terrain-compare.ts :: createJob() jobType', jobType); }

    var job = new Job(this.fourD.V).set({
      name: this.transform ? this.transform.name : this.selectedDesignTransformA.name,
      account: this.fourD.activeTeam,
      jobType: jobType,
      scene: this.mapService.scene,
      // group: this.group,
      amountPaid: false,
      compareTransformFrom : this.transform? this.transform.id : this.selectedDesignTransformA.id,
      compareTransformTo : this.selectedDesignTransformB.id,
      compareDatasetFrom : this.transform ?  this.transform.input.id : this.selectedDesignTransformA.input.id,
      compareDatasetTo : this.selectedDesignTransformB.input.id
    }).saveObservable()
    .pipe(
      flatMap(job =>
        // add the 2 terains to the job
        forkJoin([
          job.inputDatasets.addObserveable(this.transform ? this.transform.input : this.selectedDesignTransformA.input),
          job.inputDatasets.addObserveable(this.selectedDesignTransformB.input)
        ]).pipe(
          map(_ => job)
        )
      )
    ).subscribe(res1 => {
      let params = {}
      let sceneName;
      if(this.transform){
        params['A'] = encodeURIComponent(this.transform['ds_name']);
        sceneName = this.transform['ds_name'];
      }else{
        params['A'] = encodeURIComponent(this.selectedDesignTransformA['ds_name']);
        sceneName = this.selectedDesignTransformA['ds_name'];
      }
      params['B']  = encodeURIComponent(this.selectedDesignTransformB['ds_name']);
      sceneName += ' - ' + this.selectedDesignTransformB['ds_name'];
      params['name'] = sceneName;
      if ( this.debug ) { console.log ( 'terrain-compare.ts :: createJob() params', params); }
      res1.startTransform(jobType.baseTransform, params).subscribe(v => {
        this.openSnackBarInfo('MAP.TERRAIN.COMPARE_PROCESSING');
        if ( this.debug ) { console.log ( 'terrain-compare.ts :: createJob() starting', res1, v); }
        this.mapService.terranCompareStarted.next(res1.id);
      }, error1 => {
        this.openSnackBarSuccess('GENERIC.ERROR');
      })

    }, error1 => {
      this.openSnackBarSuccess('GENERIC.ERROR');
    });

  }

  cancel(){
    this.navigateBack(this.location);
  }

  ngAfterViewInit() {
    this.addSubscription( 'ar-params',
      this.ar.params.subscribe(p => {
        let trans = this.mapService.sceneTransforms.filter(v => v.id == p.transformId);
        this.transform = trans[0];
      })
    );
    this.mapService.scenes.forEach(s => {
      if(s._cachedTransforms){
        // get all unique transforms from all scenes
        s._cachedTransforms.forEach(ct => {
          if(this.allSceneTransformsA.findIndex( t => t.id === ct.id) === -1 && ct['type_uid'] === 'terrain-tiles'){
            this.allSceneTransformsA.push(ct);
          }
        })
// get all unique transforms from all scenes
        s._cachedTransforms.forEach(ct => {
          if(this.allSceneTransformsB.findIndex( t => t.id === ct.id) === -1 && ct['type_uid'] === 'terrain-tiles'){
            this.allSceneTransformsB.push(ct);
          }
        })
      }else{ // if cached transforms is not available then fetch it, this happens when terrain compare result is ready and user try to compare again
        s.children.queryObservable().subscribe(ct => {
          if(ct && ct.items.length > 0){
            // get all unique transforms from all scenes
            ct.items.forEach(ct => {
              if(this.allSceneTransformsA.findIndex( t => t.id === ct.id) === -1 && ct['type_uid'] === 'terrain-tiles'){
                this.allSceneTransformsA.push(ct);
              }
            })
// get all unique transforms from all scenes
            ct.items.forEach(ct => {
              if(this.allSceneTransformsB.findIndex( t => t.id === ct.id) === -1 && ct['type_uid'] === 'terrain-tiles'){
                this.allSceneTransformsB.push(ct);
              }
            })
          }
        })
      }
    })
  }

  destroy(){
    this.mapService.inTerrainCompare = false;
  }

}
